const ApproachSection = () => {
  const approaches = [
    {
      icon: 'ri-heart-pulse-line',
      title: '早期発見',
      description: '定期的な検査と最新の診断技術により、心不全の兆候を早期に発見。症状が進行する前に適切な治療を開始することで、予後を大きく改善します。',
    },
    {
      icon: 'ri-stethoscope-line',
      title: '検査、診断',
      description: '心エコー検査、血液検査、心電図など、多角的な検査により正確な診断を実施。専門医による詳細な評価で、患者様一人ひとりに最適な治療方針を決定します。',
    },
    {
      icon: 'ri-heart-add-line',
      title: '慢性管理',
      description: '継続的な服薬管理、生活習慣の改善指導、定期的なフォローアップにより、心不全の進行を抑制。患者様の生活の質を維持しながら、長期的な健康をサポートします。',
    },
  ];

  return (
    <section className="py-24 bg-medical-beige">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-gray-500 text-sm font-medium mb-3 uppercase tracking-wider">Our Approach</p>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 leading-tight">
            心不全管理の
            <br />
            3つの柱
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {approaches.map((approach, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-3xl hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-primary-50 rounded-2xl mb-6 group-hover:bg-primary-500 transition-all duration-300">
                <i className={`${approach.icon} text-3xl text-primary-500 group-hover:text-white transition-all duration-300`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{approach.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{approach.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
